import React, { useEffect } from "react";
import "../style.css";
import Logo from "../assets/Logo.png";
import HeroImg from "../assets/LoginHeroImg.png";
import GoogleIcon from "../assets/googleIcon.png";
import { motion } from "framer-motion";
import { UserAuth } from "../context/authContext";
import { useNavigate } from "react-router-dom";

export default function Login() {
  /**calling the googleSignIn method and user **/
  const { googleSignIn, user } = UserAuth();
  const navigate = useNavigate();

  /**the google sign in method when button is clicked**/
  const handleGoogleSignIn = async () => {
    try {
      await googleSignIn();
    } catch (error) {
      console.log(error);
    }
  };

  /***checking if there's a user when mounting the component if so we navigate to the homepage***/
  useEffect(() => {
    if (user != null) {
      navigate("/homepage");
    }
  }, [user]);

  return (
    <motion.div
      className="LoginWrapper"
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      transition={{ ease: "easeOut", duration: 0.3 }}
    >
      <div className="m-5 lg:mx-12">
        <motion.img
          src={Logo}
          className="w-10 mx-auto lg:mx-0 text-left"
          animate={{ scale: 1, opacity: 1 }}
          initial={{ scale: 0.8, opacity: 0 }}
          transition={{ ease: "easeOut", duration: 0.6 }}
        />
        <motion.div className="line"></motion.div>
        <motion.img
          src={HeroImg}
          className="HeroImg"
          animate={{ scale: 1, opacity: 1 }}
          initial={{ scale: 0.8, opacity: 0 }}
          transition={{ ease: "easeOut", duration: 0.6 }}
        />
        <motion.h1
          className="Loginh1"
          animate={{ y: 0, opacity: 1 }}
          initial={{ y: -100, opacity: 0 }}
          transition={{ ease: "easeOut", duration: 0.6, delay: 0.3 }}
        >
          The right to free speech is more important than the content of the
          speech
        </motion.h1>
        <motion.p
          className="Loginp"
          animate={{ y: 0, opacity: 1 }}
          initial={{ y: -100, opacity: 0 }}
          transition={{ ease: "easeOut", duration: 0.6, delay: 0.4 }}
        >
          Discover stories, different ideas, read on any topic from writers.
        </motion.p>
        <motion.button
          onClick={handleGoogleSignIn}
          whileHover={{
            scale: 1.07,
            transition: { duration: 0.3, delay: 0.2 },
          }}
          animate={{ y: 0, opacity: 1 }}
          initial={{ y: -70, opacity: 0 }}
          transition={{ ease: "easeOut", duration: 0.6, delay: 0.6 }}
          className="Loginbtn"
          type="button"
        >
          <img src={GoogleIcon} className="w-8 mr-1" />
          Sign in with google
        </motion.button>
      </div>
    </motion.div>
  );
}
